<div class="az-tabs">
  <div class="az-tabs-header" role="tablist">
    @for (tab of tabs; track tab) {
      <button
        class="az-tab"
        [class.az-tab-active]="isActive(tab.id)"
        [class.az-tab-disabled]="tab.disabled"
        [disabled]="tab.disabled"
        role="tab"
        [attr.aria-selected]="isActive(tab.id)"
        [attr.aria-disabled]="tab.disabled"
        (click)="selectTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    }
  </div>
  <div class="az-tabs-content" role="tabpanel">
    <ng-content></ng-content>
  </div>
</div>
